var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridiconsGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:globe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.62485 2.05029C4.52634 2.05029 2.01465 4.56198 2.01465 7.66049C2.01465 10.759 4.52634 13.2707 7.62485 13.2707C10.7234 13.2707 13.235 10.759 13.235 7.66049C13.235 4.56198 10.7234 2.05029 7.62485 2.05029ZM7.62485 12.1487L8.74689 11.0266L9.30791 10.4656V9.34355H8.18587V8.78253L7.62485 8.22151H5.94179V9.90457L7.06383 11.0266V12.1099C4.85341 11.8322 3.13669 9.94497 3.13669 7.66049L3.69771 8.22151H4.81975V7.09947H5.94179L7.62485 5.41641V4.29437H6.50281L5.94179 3.73335V3.50277C7.0207 3.06281 8.229 3.06281 9.30791 3.50277V4.29437L8.74689 4.85539V5.97743L9.30791 6.53845L11.0639 4.78246C11.4911 5.29351 11.7989 5.89341 11.9649 6.53845H10.991L9.86893 7.66049V8.78253L10.4299 9.34355H11.552L11.7124 9.504C11.0072 11.0608 9.44199 12.1487 7.62485 12.1487Z",
    fill: "#717171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsGlobe);
export default __webpack_public_path__ + "static/media/gridicons_globe.79c3ea93f6f1fb9d956d555ef4ab59fd.svg";
export { ForwardRef as ReactComponent };